export default "__VITE_PUBLIC_ASSET__ad9911cc__"